/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AgentAssistantAvailabilityEntity,
  AgentChatDto,
} from '../models/index';
import {
    AgentAssistantAvailabilityEntityFromJSON,
    AgentAssistantAvailabilityEntityToJSON,
    AgentChatDtoFromJSON,
    AgentChatDtoToJSON,
} from '../models/index';

export interface SendAgentMessageRequest {
    agentChatDto: AgentChatDto;
}

/**
 * 
 */
export class AiApi extends runtime.BaseAPI {

    /**
     * AI アシスタントが利用可能か
     */
    async getAgentAssistantAvailabilityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AgentAssistantAvailabilityEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/ai/status/agent-assistant-availability`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AgentAssistantAvailabilityEntityFromJSON(jsonValue));
    }

    /**
     * AI アシスタントが利用可能か
     */
    async getAgentAssistantAvailability(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AgentAssistantAvailabilityEntity> {
        const response = await this.getAgentAssistantAvailabilityRaw(initOverrides);
        return await response.value();
    }

    /**
     * AI エージェントへメッセージを送信し、Cursor SDK の SDKMessage を SSE（text/event-stream）でストリームする。会話状態は永続されない。
     */
    async sendAgentMessageRaw(requestParameters: SendAgentMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['agentChatDto'] == null) {
            throw new runtime.RequiredError(
                'agentChatDto',
                'Required parameter "agentChatDto" was null or undefined when calling sendAgentMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/ai/agent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgentChatDtoToJSON(requestParameters['agentChatDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * AI エージェントへメッセージを送信し、Cursor SDK の SDKMessage を SSE（text/event-stream）でストリームする。会話状態は永続されない。
     */
    async sendAgentMessage(requestParameters: SendAgentMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendAgentMessageRaw(requestParameters, initOverrides);
    }

}
